export default __webpack_public_path__ + "static/media/sync.7de73812.svg";